import { ca } from '@cian/analytics';

export function trackCardJkLinkClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ListingLayout',
    action: 'click_sopr',
    label: 'to_cardjk',
  });
}
